module.exports = __webpack_public_path__ + "static/media/logo-sm-light.7beb4315.png";